var h = Object.freeze, y = Object.defineProperty;
var l = (t, r) => h(y(t, "raw", { value: h(r || t.slice()) }));
import { L as k } from "./lds-form-element-SiTAij9m.js";
import { i as v, x as p } from "./lit-element-CwWchyls.js";
import { n as s } from "./property-EvzlnPW3.js";
import { r as g } from "./state-D88UmDIj.js";
import { e as $ } from "./query-Dk6NwgU8.js";
import { o as x } from "./if-defined-BopGAQiw.js";
import "./lds-icon.js";
import { e as E } from "./class-map-CiBNip0q.js";
var u;
const w = v(u || (u = l(["\n    :host {\n        display: inline-block;\n    }\n\n    input {\n        position: absolute;\n        opacity: 0;\n        padding: 0;\n        margin: 0;\n        pointer-events: none;\n    }\n\n    label,\n    .wrapper {\n        position: relative;\n        display: inline-flex;\n        align-items: flex-start;\n        vertical-align: middle;\n        cursor: pointer;\n    }\n\n    .wrapper.disabled label,\n    .wrapper.disabled {\n        cursor: not-allowed;\n    }\n\n    .label.has-error {\n        color: var(--lds-color-error);\n    }\n\n    input:disabled {\n        cursor: not-allowed;\n    }\n\n    input:focus-visible ~ .control {\n        outline: auto;\n    }\n\n    .control {\n        background-color: var(--lds-color-default-20);\n        border-radius: var(--lds-input-border-radius);\n        width: var(--lds-checkbox-size);\n        height: var(--lds-checkbox-size);\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        border-width: var(--lds-input-border-width);\n        border-style: solid;\n        border-color: transparent;\n    }\n\n    .disabled .control,\n    .disabled .readonly {\n        opacity: var(--lds-disabled-opacity);\n    }\n\n    .control.checked {\n        background-color: var(--lds-color-primary);\n        color: var(--lds-text-invert);\n    }\n\n    .label {\n        margin-inline-start: 0.5em;\n        line-height: var(--lds-checkbox-size);\n    }\n\n    .has-error {\n        border-color: var(--lds-color-error);\n    }\n"])));
var I = Object.defineProperty, i = (t, r, n, C) => {
  for (var o = void 0, a = t.length - 1, c; a >= 0; a--)
    (c = t[a]) && (o = c(r, n, o) || o);
  return o && I(r, n, o), o;
}, f, b;
const d = class d extends k {
  constructor() {
    super(...arguments), this.value = "", this.name = void 0, this.disabled = !1, this.readonly = !1, this.required = !1, this.checked = !1, this.hasError = !1;
  }
  get validationElement() {
    return this.input;
  }
  get formValue() {
    var r;
    return this.checked ? (r = this.value) != null ? r : "on" : null;
  }
  onInputKeyUp(r) {
    r.key === "Enter" && this.onClick();
  }
  render() {
    return p(b || (b = l([' <div class="wrapper ', '" part="wrapper">\n            <input\n                @click=', '\n                type="checkbox"\n                part="input"\n                id="input"\n                .value=', "\n                ?disabled=", "\n                ?readonly=", "\n                ?required=", "\n                ?checked=", "\n                name=", "\n                @keyup=", "\n                aria-checked=", " />\n            <div\n                @click=", '\n                class="control', '">\n                ', '\n            </div>\n            <label for="input" part="label" class="label ', '">\n                <slot></slot>\n            </label>\n        </div>'])), this.disabled ? "disabled" : "", this.onClick, this.value, this.disabled, this.readonly, this.required, this.checked, x(this.name), this.onInputKeyUp, this.checked ? "true" : "false", this.onClick, E({
      "has-error": this.hasError,
      checked: this.checked
    }), this.checked ? p(f || (f = l(['<lds-icon name="check" part="checked"></lds-icon>']))) : "", this.hasError ? "has-error" : "");
  }
  onClick() {
    this.disabled || this.readonly || (this.checked = !this.checked, this.emit("change", { checked: this.checked }));
  }
  updated(r) {
    if (!this.ranFirstUpdatedCycle) {
      this.ranFirstUpdatedCycle = !0;
      return;
    }
    super.updated(r), r.has("checked") && (this.updateForm(), this.hasError = !this.checkValidity());
  }
};
d.styles = w;
let e = d;
i([
  s()
], e.prototype, "value");
i([
  $("input")
], e.prototype, "input");
i([
  s({ type: String })
], e.prototype, "name");
i([
  s({ type: Boolean, reflect: !0 })
], e.prototype, "disabled");
i([
  s({ type: Boolean, reflect: !0 })
], e.prototype, "readonly");
i([
  s({ type: Boolean, reflect: !0 })
], e.prototype, "required");
i([
  s({ type: Boolean, reflect: !0 })
], e.prototype, "checked");
i([
  g()
], e.prototype, "hasError");
const m = new URL(import.meta.url), V = m.searchParams.has("debug");
if (!m.searchParams.has("no-define")) {
  const t = customElements.get("lds-checkbox");
  t ? t.VERSION !== e.VERSION && V && console.log("%clds-checkbox tried loading in version ".concat(e.VERSION, ", but lds-checkbox is already defined as ").concat(t.VERSION), "font-weight: bold; font-size: 16px; color: red;") : customElements.define("lds-checkbox", e);
}
export {
  e as LdsCheckbox
};
